module.exports = __webpack_public_path__ + "img/three3Red.37a2dd1c.jpg";